import { render, staticRenderFns } from "./Meta.vue?vue&type=template&id=9c64687a&"
import script from "./Meta.vue?vue&type=script&lang=js&"
export * from "./Meta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButtonIcon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Button/Icon.vue').default,UiAvatar: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Avatar.vue').default,Menu: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Menu/index.vue').default,UiButton: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Button/index.vue').default})
